import { BreakUiCoursesComponent } from './features/courses/components/break-ui-courses/break-ui-courses.component';
import { TagsGridRendererComponent } from './features/quizzes/components/tags-grid-renderer/tags-grid-renderer.component';
// tslint:disable: max-line-length
import { CommonModule } from '@angular/common';
import { ErrorHandler, NgModule } from '@angular/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AgGridModule } from 'ag-grid-angular';
import { OrderListModule } from 'primeng/orderlist';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TabViewModule } from 'primeng/tabview';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { AppRoutingModule } from './app-routing.module';

import {
  DevwareCoreModule,
  DevwareOrmModule,
  DevwareUIModule,
  DevwareAGGridModule,
  DevwareUILayoutModule,
  DevwareUIMetaDataModule,
  DevwareAdminModule,
  DevwareUiWizardModule,
  DevwareMediaModule,
  DevwareChartsModule,
  DwMetaDataListService,
  DwMetaDataGridService,
  DwTermsOfServiceManagerService
} from '@devwareapps/devware-cap';

import { AppDevwareConfigProviderService } from './app-devware-config-provider.service';
import { QuizInsightsGridConfigService } from './features/quizzes/services/quiz-insights-grid-config.service';


import { AppComponent } from './pages/app/app.component';
import { HomeComponent } from './features/shared/pages/home/home.component';


import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AccordionModule } from 'primeng/accordion';
import { TreeModule } from 'primeng/tree';
import { ContextMenuModule } from 'primeng/contextmenu';
import { MenuModule } from 'primeng/menu';
import { ProgressBarModule } from 'primeng/progressbar';
import { CheckboxModule } from 'primeng/checkbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { SliderModule } from 'primeng/slider';
import { DwTaskContainerComponent } from './features/z-devware/tasks/components/dw-task-container/dw-task-container.component';


import { ChartModule } from 'primeng/chart';
import { AviatorOnlineHomePageComponent } from './features/homepage/components/aviator-online-home-page/aviator-online-home-page.component';
import { AppDevwareBootstrapService } from './app-devware-registrations.service';
import { CourseCardComponent } from './features/courses/components/cards/course-card/course-card.component';
import { CoursesCardRedesignComponent } from './features/courses/components/cards/courses-card-redesign/courses-card-redesign.component';
import { DesignSystemModule } from './shared/design-system/design-system.module';
import { ScenariosModule } from './features/scenarios/scenarios.module';
import { AviatorMetadataListService } from './features/shared/services/aviator-metadata-list.service';
import { SidebarSectionMenuProcessorService } from './features/shared/services/sidebar-section-menu-processor.service';
//import { MarketplaceEmptyCardComponent } from './features/courses/components/cards/marketplace-empty-card/marketplace-empty-card.component';
import { CourseBreadcrumbProcessor } from './features/courses/breadcrumb/course-breadcrumb-customiziner.service';
import { CourseNavigationComponent } from './features/courses/components/course-navigation/course-navigation.component';
import { ModuleCardComponent } from './features/courses/components/cards/module-card/module-card.component';
import { CourstListDataSourceService } from './features/courses/data-sources/course-list-data-source.service';
import { ModuleListDataSourceService } from './features/courses/data-sources/module-list-data-source.service';
import { LessonCardComponent } from './features/courses/components/cards/lesson-card/lesson-card.component';
import { LessonNavigationComponent } from './features/courses/components/lesson-navigation/lesson-navigation.component';
import { LessonUiComponent } from './features/courses/components/lesson-ui/lesson-ui.component';
import { ModuleDetailViewComponent } from './features/courses/components/module-detail-view/module-detail-view.component';
import { CourseDetailViewComponent } from './features/courses/components/course-detail-view/course-detail-view.component';
import { CourseCapFormHostComponent } from './features/courses/components/course-cap-form-host/course-cap-form-host.component';
import { VideoHostComponent } from './features/videos/components/video-host/video-host.component';
import { VideoPlayerBunnyComponent } from './features/videos/components/streaming-providers/bunny/components/video-player-bunny/video-player-bunny.component';
import { VideoPlayerBunnyHlsComponent } from './features/videos/components/streaming-providers/bunny/components/video-player-bunny-hls/video-player-bunny-hls.component';
import { VideoPlayerApiVideoComponent } from './features/videos/components/streaming-providers/apivideo/components/video-player-apivideo/video-player-apivideo.component';
import { VideoPlayerBaseComponent } from './features/videos/components/streaming-providers/base/video-player-base.component';
import { LessonListDataSourceService } from './features/courses/data-sources/lesson-list-data-source.service';
import { QuizComponent } from './features/quizzes/components/quiz/quiz.component';
import { QuizQuestionComponent } from './features/quizzes/components/quiz-question/quiz-question.component';
import { QuizHomeComponent } from './features/quizzes/components/quiz-home/quiz-home.component';
import { QuizAnswerTrueFalseComponent } from './features/quizzes/components/answers/quiz-answer-true-false/quiz-answer-true-false.component';
import { QuizAnswerMultipleChoiceComponent } from './features/quizzes/components/answers/quiz-answer-multiple-choice/quiz-answer-multiple-choice.component';
import { QuizAnswerMultipleAnswerComponent } from './features/quizzes/components/answers/quiz-answer-multiple-answer/quiz-answer-multiple-answer.component';
import { QuizAnswerBaseComponent } from './features/quizzes/components/answers/base/quiz-answer-base.component';
import { QuizAnswerHostComponent } from './features/quizzes/components/answers/quiz-answer-host/quiz-answer-host.component';
import { QuizResultComponent } from './features/quizzes/components/quiz-result/quiz-result.component';
import { QuizResultsComponent } from './features/quizzes/components/quiz-results/quiz-results.component';
import { QuizCardComponent } from './features/quizzes/components/cards/quiz-card/quiz-card.component';
import { TimeDurationPipe } from './features/shared/pipes/time-duration.pipe';
import { LocalDateTimePipe } from './features/shared/pipes/local-date-time.pipe';
import { VideoUploadActionService } from './features/videos/actions/video-upload-action.service';
import { VideoUploadModalComponent } from './features/videos/components/video-upload-modal/video-upload-modal.component';
import { UserRegistrationComponent } from './features/homepage/components/user-registration/user-registration.component';
import { CurrentFlightSchoolContextService } from './features/schools/contexts/current-school-context.service';
import { CourseStudentProgressCardComponent } from './features/courses/components/cards/course-student-progress-card/course-student-progress-card.component';
import { ModuleStudentProgressCardComponent } from './features/courses/components/cards/module-student-progress-card/module-student-progress-card.component';
import { ModuleStudentProgressCardHeaderComponent } from './features/courses/components/cards/module-student-progress-card-header/module-student-progress-card-header.component';
import { BaseCardComponent } from './features/courses/components/cards/base-card/base-card.component';
import { DwCardDesignerComponent } from './features/z-devware/cards/components/dw-card-designer/dw-card-designer.component';
import { CourseStudentProgressFormCardComponent } from './features/courses/components/cards/course-student-progress-form-card/course-student-progress-form-card.component';
import { CourseStudentProgressComponent } from './features/courses/components/course-student-progress/course-student-progress.component';
import { CourseStudentProgressRedesignComponent } from './features/courses/components/course-student-progress-redesign/course-student-progress-redesign.component';
import { StudentModuleLessonActivityGridRendererComponent } from './features/courses/components/student-module-lesson-activity-grid-renderer/student-module-lesson-activity-grid-renderer.component';
import { LessonStudentProgressCardComponent } from './features/courses/components/cards/lesson-student-progress-card/lesson-student-progress-card.component';
import { QuizResultsModalComponent } from './features/quizzes/components/quiz-results-modal/quiz-results-modal.component';
import { ShowQuizResultModalActionService } from './features/quizzes/actions/show-quiz-result-modal-action.service';
import { StudentCourseProgressListDataSourceService } from './features/courses/data-sources/student-course-progress-list-data-source.service';
import { LinkQuestionsModalComponent } from './features/quizzes/components/link-questions-modal/link-questions-modal.component';
import { QuestionFormLayoutWidgetComponent } from './features/quizzes/components/question-form-layout-widget/question-form-layout-widget.component';
import { QuizFormLayoutWidgetComponent } from './features/quizzes/components/question-form-layout-widget/quiz-form-layout-widget.component';
import { LinkQuestionActionsService } from './features/quizzes/actions/link-questions-action.service';
import { CurrentStudentContextService } from './features/students/contexts/current-student-context.service';
import { AssignmentUtilComponent } from './features/schools/components/assignment-util/assignment-util.component';
import { AssignmentStudentDetailActionService } from './features/schools/actions/assignment-student-detail-action.service';
import { AssignmentStudentSetProgressActionService } from './features/schools/actions/assignment-student-reset-progress.service';
import { AnnonymousHomeViewComponent } from './features/homepage/components/annonymous-home-view/annonymous-home-view.component';
import { AuthenticatedHomeViewComponent } from './features/homepage/components/authenticated-home-view/authenticated-home-view.component';
import { StudentDashboardComponent } from './features/students/components/student-dashboard/student-dashboard.component';
import { LessonCardHomePageComponent } from './features/courses/components/cards/lesson-card-home-page/lesson-card-home-page.component';
import { AssignmentCardComponent } from './features/schools/components/cards/assignment-card/assignment-card.component';
import { AssignmentStudentCurrentDataSourceService } from './features/schools/data-sources/assignment-student-current-data-source.service';
import { DurationSecondsColumnRendererService } from './features/shared/components/columns/duration-seconds-column/duration-seconds-column-renderer-service.';
import { UsreAvatarComponent } from './features/shared/components/usre-avatar/usre-avatar.component';
import { CurrentUserContextService } from './features/shared/contexts/current-user-context.service';
import { UrlParameterContextService } from './features/shared/contexts/url-parameter-context.service';
import { ManageStudentContextService } from './features/schools/contexts/manage-student-context.service';
import { AssignCourseUtilComponent } from './features/schools/components/assign-course-util/assign-course-util.component';
import { VideoAdminPreviewComponent } from './features/videos/components/video-admin-preview/video-admin-preview.component';
import { AssignmentLessonCardComponent } from './features/schools/components/cards/assignment-lesson-card/assignment-lesson-card.component';
import { AssignmentCardMyAssignmentsRedesignComponent } from './features/schools/components/cards/assignment-card-my-assignments-redesign/assignment-card-my-assignments-redesign.component';
import { AssignmentStudentDataSourceService } from './features/schools/data-sources/assignment-student-data-source.service';
import { AssignmentStudentLessonProgressComponent } from './features/schools/components/assignment-student-lesson-progress/assignment-student-lesson-progress.component';
import { AssignmentStudentProgressFormSectionComponent } from './features/schools/components/assignment-student-progress-form-section/assignment-student-progress-form-section.component';
import { AssignmentStudentGridRendererComponent } from './features/schools/components/assignment-student-grid-renderer/assignment-student-grid-renderer.component';
import { AssignmentFormFooterStatusComponent } from './features/schools/components/assignment-form-footer-status/assignment-form-footer-status.component';
import { AssignmentsGridRendererComponent } from './features/schools/components/assignments-grid-renderer/assignments-grid-renderer.component';
import { StudentCourseDeleteActionService } from './features/schools/actions/student-course-delete-action.service';
import { StudentResetCourseProgressActionService } from './features/schools/actions/student-reset-course-progress-action.service';
import { SchoolDashboardComponent } from './features/schools/components/school-dashboard/school-dashboard.component';
import { InstructorDashboardComponent } from './features/instructors/components/instructor-dashboard/instructor-dashboard.component';
import { MyStudentsGridRendererComponent } from './features/instructors/components/my-students-grid-renderer/my-students-grid-renderer.component';
import { StudentCardComponent } from './features/students/components/cards/student-card/student-card.component';
import { InstructorStudentDataSourceService } from './features/instructors/data-sources/instructor-student-data-source.service';
import { AddStudentByCodeActionService } from './features/instructors/actions/add-student-by-code-action.service';
import { AddStudentByCodeModalComponent } from './features/instructors/components/add-student-by-code-modal/add-student-by-code-modal.component';
import { StudentTrainingCodeFormSectionComponent } from './features/students/components/student-training-code-form-section/student-training-code-form-section.component';
import { CurrentInstructorContextService } from './features/instructors/contexts/current-instructor-context.service';
import { SchoolStudentDataSourceService } from './features/schools/data-sources/school-student-data-source.service';
import { ModuleProgressListDataSourceService } from './features/courses/data-sources/module-progress-list-data-source.service';
import { MyFlightSchoolContextService } from './features/schools/contexts/my-school-context.service';
import { VideoReplaceFormActionService } from './features/videos/actions/video-replace-form-action.service';
import { VideoRevertToHistoryActionService } from './features/videos/actions/video-revert-to-history-action.service';
import { VideoUpdateStatusActionService } from './features/videos/actions/video-update-status-action.service';
import { DwMagicImage2Directive } from './features/z-devware/visualizations/components/dw-magic-image2/dw-magic-image2.directive';
import { DwImage2Component } from './features/z-devware/visualizations/components/dw-image2/dw-image2.component';
import { UserRoleDetailsContextService } from './features/schools/contexts/user-role-details-context.service';
import { ManagerUserUtilComponent } from './features/schools/components/manager-user-util/manager-user-util.component';
import { DwAssignmentLessonCountValidationRule } from './features/schools/validators/assignment-lesson-count-validator.service';
import { DwAssignmentStudentCountValidationRule } from './features/schools/validators/assignment-student-count-validator.service';
import { UpdateAllStudentProgressActionService } from './features/schools/actions/course-update-all-student-progress-action.service';
import { ReprocessStudentGamificationActionService } from './features/gamification/actions/reprocess-student-gamification-action.service';
import { DeleteDailyQuizActionService } from './features/gamification/actions/delete-daily-quiz-action.service';
import { InstructorAssignStudentsSaveActionService } from './features/schools/actions/instructor-assign-students-save-action.service';
import { LessonSelectionTreeFormControlComponent } from './features/shared/components/lesson-selection-tree-form-control/lesson-selection-tree-form-control.component';
import { LessonSelectionTreeControlComponent } from './features/shared/components/lesson-selection-tree-control/lesson-selection-tree-control.component';
import { LessonSelectionListControlComponent } from './features/shared/components/lesson-selection-list-control/lesson-selection-list-control.component';
import { LessonSelectionListFormControlComponent } from './features/shared/components/lesson-selection-list-form-control/lesson-selection-list-form-control.component';
import { LessonSelectionReadonlyListFormControlComponent } from './features/shared/components/lesson-selection-readonly-list-form-control/lesson-selection-readonly-list-form-control.component';
import { AssignmentStatusFormControlComponent } from './features/shared/components/assignment-status-form-control/assignment-status-form-control.component';
import { AssignmentCourseFormControlComponent } from './features/shared/components/assignment-course-form-control/assignment-course-form-control.component';
import { ExpirationDateTimeReadonlyFormControlComponent } from './features/shared/components/expiration-date-time-readonly-form-control/expiration-date-time-readonly-form-control.component';
import { UserBreadcrumbProcessor } from './features/schools/breadcrumbs/user-breadbrumb-processor.service';
import { FlagLessonModalComponent } from './features/courses/components/flag-lesson-modal/flag-lesson-modal.component';
import { StudentCourseEndorsementContextService } from './features/courses/contexts/student-course-endorsement-context.service';
import { StudentCourseTimeSpentContextService } from './features/courses/contexts/student-course-time-spent-context.service';
import { EndorsementStudentEditComponent } from './features/schools/components/endorsement-student-edit/endorsement-student-edit.component';
import { CourseHelperContextContextService } from './features/courses/contexts/course-helper-context.service';
import { FlightSchoolSettingsComponent } from './features/schools/components/flight-school-settings/flight-school-settings.component';
import {
  FlightSchoolMarketplaceFormSectionComponent
} from './features/schools/components/flight-school-marketplace-form-section/flight-school-marketplace-form-section.component';
import { StudentUpdateCourseProgressActionService } from './features/schools/actions/student-update-course-progress-action.service';
import { RegardeQuizActionsService } from './features/quizzes/actions/regrade-quiz-action.service';
import { ResendJoinRequestActionService } from './features/schools/actions/resend-join-request-action.service';
import { AviatorUserContextCustomizerService } from './features/admin/contexts/aviator-user-context-customizer.service';

import { PaymentsCreatePaymentComponent } from './features/lab/components/lab-payments/payments-create-payment.component';
import { PaymentsAddPaymentComponent } from './features/payments/components/add-payment/payments-add-payment.component';
import { StudentPurchaseCourseComponent } from './features/payments/components/student-purchase-course/student-purchase-course.component';
import { ChangeSchoolSubscriptionComponent } from './features/payments/components/subscription/change-school-subscription.component';
import { SchoolBillingDetailsComponent } from './features/payments/components/billing-details/school-billing-details.component';
import { SchoolBillingDetailsUtilComponent } from './features/payments/components/billing-details/school-billing-details-util.component';
import {
  BillingProfileFormSectionComponent
} from './features/payments/components/billing-profile-form-section/billing-profile-form-section.component';
import { StudentBillingDetailsUtilComponent } from './features/payments/components/billing-details/student-billing-details-util.component';
import { LabPaymentsComponent } from './features/lab/components/lab-payments/lab-payments.component';

import { DwMenuProcessorToken, DwUserContextDynamicHandlerToken } from '@devwareapps/devware-cap';
import { SetUserTypeComponent } from './features/admin/menus/set-user-type/set-user-type.component';
import { SchoolSelectionModalComponent } from './features/admin/components/school-selection-modal/school-selection-modal.component';
import { SchoolSelectionModalActionService } from './features/admin/actions/school-select-modal-action.service';
import { StudentOnboardingModalComponent } from './features/students/components/student-onboarding-modal/student-onboarding-modal.component';
import { StudentOnboardingActionService } from './features/students/actions/student-onboarding-action.service';
import {
  TestEmulatedAcknowledgementsActionService
} from './features/post-login/actions/test-emulated-acknowledgements-action.service';
import { LoginSideImagePickerComponent } from './features/schools/components/login-side-image-picker/login-side-image-picker.component';
import { SchoolBrandingSetupComponent } from './features/schools/components/school-branding-setup/school-branding-setup.component';
import { SchoolSettingsDataSourceService } from './features/schools/data-sources/school-settings-data-source.service';
import { DwThemePropertyEditorComponent } from './features/z-devware/components/dw-theme-property-editor/dw-theme-property-editor.component';
import { DwColorSetPickerComponent } from './features/z-devware/components/dw-color-set-picker/dw-color-set-picker.component';
import { DwMediaSelector2Component } from './features/z-devware/components/dw-media-selector2/dw-media-selector2.component';
import { VideoThumbnailComponent } from './features/videos/components/video-thumbnail/video-thumbnail.component';
import { StudentChangeSchoolModalComponent } from './features/schools/components/student-change-school-modal/student-change-school-modal.component';
import { StudentChangeSchoolActionService } from './features/schools/actions/student-change-school-action.service';
import { CoursePageComponent } from './features/courses/components/course-page/course-page.component';
import { CourstListMarketplaceDataSourceService } from './features/courses/data-sources/course-list-marketplace-data-source.service';
import { PurchaseCourseModalComponent } from './features/payments/components/purchase-course-modal/purchase-course-modal.component';
import { DiscountCodeComponent } from './features/payments/components/discount-code/discount-code.component';
import { NgxStripeModule } from 'ngx-stripe';
import { PurchaseCourseUtilComponent } from './features/payments/components/purchase-course-util/purchase-course-util.component';
import { CoursePurchaseActionService } from './features/schools/actions/course-purchase-action.service';
import { SchoolFeatureContextService } from './features/schools/contexts/school-features-context.service';
import { CustomerPortalViewActionService } from './features/payments/actions/customer-portal-view-action.service';
import { SchoolOverrideHttpInterceptor } from './features/admin/http-inteceptors/school-override-http-interceptor.service';
import { CourseTotalTimeUpdateActionService } from './features/courses/actions/course-total-time-update-action.service';
import { CourseAssignAllSchoolsActionService } from './features/courses/actions/course-assign-all-schools-action.service';
import { DurationFormControlComponent } from './features/shared/components/duration-form-control/duration-form-control.component';
import { MobilePhoneFormControlComponent } from './features/shared/components/mobile-phone-form-control/mobile-phone-form-control.component';
import { PresetDateTimeFormControlConfigComponent } from './features/shared/components/preset-date-time-form-control/preset-date-time-form-control-config.component';
import { PresetDateTimeFormControlComponent } from './features/shared/components/preset-date-time-form-control/preset-date-time-form-control.component';
import { SelectedCourseReadonlyFormControlComponent } from './features/shared/components/selected-course-readonly-form-control/selected-course-readonly-form-control.component';
import { EmailAddressListControlComponent } from './features/shared/components/email-address-list-control/email-address-list-control.component';
import { JoinRequestEmailListFormSectionComponent } from './features/shared/components/join-request-email-list-form-section/join-request-email-list-form-section.component';
import { DomainListControlComponent } from './features/shared/components/domain-list-control/domain-list-control.component';
import { FlightSchoolRegistrationDomainsFormSectionComponent } from './features/schools/components/flight-school-registration-domains-form-section/flight-school-registration-domains-form-section.component';
import { StudentGroupSelectComponent } from './features/shared/components/student-group-select/student-group-select.component';
import { StudentGroupMultiSelectComponent } from './features/shared/components/student-group-multi-select/student-group-multi-select.component';
import { StudentGroupSelectFormSectionComponent } from './features/shared/components/student-group-select-form-section/student-group-select-form-section.component';
import { CoursePurchaseStudentGroupSelectFormSectionComponent } from './features/shared/components/course-purchase-student-group-select-form-section/course-purchase-student-group-select-form-section.component';
import { IntegrationDataHttpInterceptor } from './features/integration/http-interceptors/integration-data-http-interceptor.service';
import { AviatorRouteGuardService } from './features/shared/route-guards/aviator-route-guard.service';
import { CourseMarketplaceCardComponent } from './features/courses/components/cards/course-marketplace-card/course-marketplace-card.component';
import { MarketplaceEmptyCardRedesignComponent } from './features/courses/components/cards/marketplace-empty-card-redesign/marketplace-empty-card-redesign.component';

import { EnabledProfitSharingActionService } from './features/payments/actions/create-payout-account-action.service'
import { ResetProfitSharingActionService } from './features/payments/actions/reset-payout-account-action.service';
import { ProfitSharingDetailsComponent } from './features/payments/components/profit-sharing-details/profit-sharing-details.component'
import { ProfitSharingSummaryComponent } from './features/payments/components/profit-sharing-summary/profit-sharing-summary.component';
import { DwMiniTileComponent } from './features/z-devware/visualizations/components/dw-mini-tile/dw-mini-tile.component';
import { RemovePaymentMethodActionService } from './features/payments/actions/remove-payment-method-action.service';
import { RecreateProcessorCustomerActionService } from './features/payments/actions/recreate-processor-customer-action.service';
import { environment } from '../environments/environment';
import { SchoolSelectGridAction } from './features/admin/actions/school-select-grid-action.service';
import { EmulateUserContextFormActionService, EmulateUserContextGridActionService } from './features/admin/actions/emulate-user-context-action.service';
import { VideoModalComponent } from './features/videos/components/video-modal/video-modal.component';
import { DwImageZoomModalComponent } from './features/z-devware/visualizations/components/dw-image-zoom-modal/dw-image-zoom-modal.component';

import { GalleriaModule } from 'primeng/galleria';
import { MainDashboardComponent } from './features/homepage/components/main-dashboard/main-dashboard.component';
import { LessonCardHomePage2Component } from './features/courses/components/cards/lesson-card-home-page2/lesson-card-home-page2.component';
import { ContinuingHomePageCardComponent } from './features/courses/components/cards/continuing-home-page-card/continuing-home-page-card.component';
import { ContinuingHomePageCardRedesignComponent } from './features/courses/components/cards/continuing-home-page-card-redesign/continuing-home-page-card-redesign.component';
import { UpNextHeroCardComponent } from './features/courses/components/cards/up-next-hero-card/up-next-hero-card.component';
import { ProgramTileCardComponent } from './features/courses/components/cards/program-tile-card/program-tile-card.component';
import { BreakUiHomepageComponent } from './features/homepage/components/break-ui-homepage/break-ui-homepage.component';
import { MainDashboardRedesignComponent } from './features/homepage/components/main-dashboard-redesign/main-dashboard-redesign.component';
import { CertProgressHeaderComponent } from './features/homepage/components/cert-progress-header/cert-progress-header.component';
import { StreakQuizCardMockComponent } from './features/homepage/components/streak-quiz-card-mock/streak-quiz-card-mock.component';
import { DailyQuizPageComponent } from './features/quizzes/components/daily-quiz-page/daily-quiz-page.component';
import { StatStripMockComponent } from './features/homepage/components/stat-strip-mock/stat-strip-mock.component';
import { DueSoonMockComponent } from './features/homepage/components/due-soon-mock/due-soon-mock.component';
import { AchievementsPageComponent } from './features/gamification/components/achievements-page/achievements-page.component';
import { LadderDetailSheetComponent } from './features/gamification/components/ladder-detail-sheet/ladder-detail-sheet.component';
import { TierEarnedSheetComponent } from './features/gamification/components/tier-earned-sheet/tier-earned-sheet.component';
import { AchievementsWithinReachMockComponent } from './features/gamification/components/achievements-within-reach-mock/achievements-within-reach-mock.component';
import { CreateSchoolModalComponent } from './features/integration/components/create-school-modal/create-school-modal.component';
import { AssignmentCardNewComponent } from './features/schools/components/cards/assignment-card-new/assignment-card-new.component';
import { AssignmentRowCardComponent } from './features/schools/components/cards/assignment-row-card/assignment-row-card.component';
import { ChangeSchoolSubscriptionModalComponent } from './features/payments/components/change-school-subscription-modal/change-school-subscription-modal.component';
import { StandardProgressBarComponent } from './features/shared/components/standard-progress-bar/standard-progress-bar.component';
import { SubscriptionSettingsComponent } from './features/payments/components/subscription-settings/subscription-settings.component';
import { SubscriptionSettingsRedesignComponent } from './features/payments/components/subscription-settings-redesign/subscription-settings-redesign.component';
import { AssignmentBlankCardComponent } from './features/schools/components/cards/assignment-blank-card/assignment-blank-card.component';
import { AssignmentBlankCardMyAssignmentsRedesignComponent } from './features/schools/components/cards/assignment-blank-card-my-assignments-redesign/assignment-blank-card-my-assignments-redesign.component';
import { NoAssignmentsCardRedesignComponent } from './features/schools/components/cards/no-assignments-card-redesign/no-assignments-card-redesign.component';
import { UserImageColumnComponent } from './features/schools/columns/user-image-column/user-image-column.component';
import { AviatorLoginPageComponent } from './features/homepage/components/aviator-login-page/aviator-login-page.component';
import { AviatorRegistrationPageComponent } from './features/homepage/components/aviator-registration-page/aviator-registration-page.component';
import { AviatorLookupDropdownComponent } from './features/homepage/components/aviator-lookup-dropdown/aviator-lookup-dropdown.component';
import { CourseLessonProgressAssignmentDataSourceService } from './features/courses/data-sources/course-lesson-progress-assignment-data-source.service';
import { AssignmentStudentHomePageDataSourceService } from './features/schools/data-sources/assignment-student-homepage-data-source.service';
import { AviatorNotFoundComponent } from './features/homepage/components/aviator-not-found/aviator-not-found.component';
import { LessonAssignAcsTasksAction } from './features/courses/actions/lesson-assign-acs-tasks.service';
import { DwLoginRegistrationInfoProviderService } from './features/homepage/services/dw-login-registration-info-provider.service';
import { CourseSubmitAcsWrittenActionService } from './features/students/actions/course-submit-acs-written-action.service';
import { CourseAcsWrittenResultsComponent } from './features/students/components/course-acs-written-results/course-acs-written-results.component';
import { StudentModuleProgressContextService } from './features/courses/contexts/student-module-progress-context.service';
import { CourseAcsWrittenResultsAdminViewComponent } from './features/students/components/course-acs-written-results-admin-view/course-acs-written-results-admin-view.component';
import { StudentActivityFormSectionComponent } from './features/students/components/student-activity-form-section/student-activity-form-section.component';
import { NutrientPdfViewerComponent } from './features/lab/components/nutrient-pdf-viewer/nutrient-pdf-viewer.component';
import { DocumentCardComponent } from './features/documents/components/cards/document-card/document-card.component';
import { DocumentPdfViewerComponent } from './features/documents/components/document-pdf-viewer/document-pdf-viewer.component';
import { FarAimViewerPageComponent } from './features/documents/structured-content/components/far-aim-viewer-page/far-aim-viewer-page.component';
import { DocumentViewerComponent } from './features/documents/components/document-viewer/document-viewer.component';
import { DocumentReferenceViewerComponent } from './features/documents/components/document-reference-viewer/document-reference-viewer.component';
import { DocumentReferenceStructuredContentComponent } from './features/documents/components/document-reference-structured-content/document-reference-structured-content.component';
import { DocumentReferenceStructuredViewerComponent } from './features/documents/components/document-reference-structured-viewer/document-reference-structured-viewer.component';
import { DocumentEmbeddedViewerComponent } from './features/documents/components/document-embedded-viewer/document-embedded-viewer.component';
import { StructuredDocumentViewerComponent } from './features/documents/structured-content/components/structured-document-viewer/structured-document-viewer.component';
import { StructuredDocumentContentComponent } from './features/documents/structured-content/components/structured-document-content/structured-document-content.component';
import { DocumentItemAiProcessingComponent } from './features/documents/components/document-item-ai-processing/document-item-ai-processing.component';
import { FarAimProcessingComponent } from './features/documents/components/far-aim-processing/far-aim-processing.component';
import { FlightSchoolSettingsConfigComponent } from './features/schools/components/flight-school-settings/config/flight-school-settings-config/flight-school-settings-config.component';
import { ReportCourseTilesComponent } from './features/reports/components/report-course-tiles/report-course-tiles.component';
import { ReportCourseStatCardComponent } from './features/reports/components/cards/report-course-stat-card/report-course-stat-card.component';
import { AssignmentStudentAddModalService } from './features/schools/actions/assignment-student-add-modal-action.service';
import { AssignmentAddStudentsActionService } from './features/schools/actions/assignment-add-students-action.service';
import { AssignmentAddStudentsModalComponent } from './features/schools/components/assignment-add-students-modal/assignment-add-students-modal.component';
import { RecreateEndorsementsActionService } from './features/courses/actions/course-recreate-endorsements-action.service';
import { ReundInvoiceActionService } from './features/payments/actions/refund-invoices-action.service';
import { OpenStripeInvoiceActionService } from './features/payments/actions/open-stripe-invoice-action.service';
import { DocumentLessonComponent } from './features/documents/components/document-lesson/document-lesson.component';
import { ReportingPageComponent } from './features/reporting/pages/reporting-page/reporting-page.component';
import { UserAvatorComponent } from './features/shared/components/user-avator/user-avator.component';
import { AviatorAvatarComponent } from './features/shared/components/aviator-avatar/aviator-avatar.component';
import { AviatorAvatarColumnComponent } from './features/shared/components/columns/aviator-avatar-column/aviator-avatar-column.component';
import { AviatorAvatarColumnConfigComponent } from './features/shared/components/columns/aviator-avatar-column/aviator-avatar-column-config/aviator-avatar-column-config.component';
import { VideoThumbnailGridColumnComponent } from './features/videos/components/video-thumbnail-grid-column/video-thumbnail-grid-column.component';
import { DateRangeFilterComponent } from './features/reporting/components/date-range-filter/date-range-filter.component';
import { EmptyStateComponent } from './features/shared/components/empty-state/empty-state.component';
import { ReportingSkeletonComponent } from './features/reporting/components/reporting-skeleton/reporting-skeleton.component';
import { ReportingUsersDetailGridComponent } from './features/reporting/components/reporting-users-detail-grid/reporting-users-detail-grid.component';
//import { SideEditComponent } from './features/documents/components/side-edit/side-edit.component';
import { DocumentEditComponent } from './features/documents/components/edit-panels/document-edit/document-edit.component';
import { DocumentsPageComponent } from './features/documents/components/documents-page/documents-page.component';
import { DocumentCardOldComponent } from './features/documents/components/cards/document-card-old/document-card-old.component';
import { DocumentsBreadcrumbProcessor } from './features/documents/breadcrumb/documents-breadcrumb-customizer.service';
import { SideEditSheetComponent } from './features/documents/components/side-edit-sheet/side-edit-sheet.component';
import { FolderEditComponent } from './features/documents/components/edit-panels/folder-edit/folder-edit.component';
import { FolderSelectorComponent } from './features/documents/components/folder-selector/folder-selector.component';
import { AddDocumentDropdownComponent } from './features/documents/components/add-document-dropdown/add-document-dropdown.component';
import { ToggleSwitchComponent } from './features/shared/components/toggle-switch/toggle-switch.component';
import { ManageUserCalloutsComponent } from './features/schools/components/manage-user-callouts/manage-user-callouts.component';
import { ManageUsersSkeletonComponent } from './features/schools/components/manage-users-skeleton/manage-users-skeleton.component';
import { ManageUsersTableComponent } from './features/schools/components/manage-users-table/manage-users-table.component';
import { DwPubSubMonitorComponent } from './features/z-devware/pubsub/components/dw-pubsub-monitor/dw-pubsub-monitor.component';
import { BunnyPlayerjsTestComponent } from './features/videos/components/streaming-providers/bunny/components/bunny-playerjs-test/bunny-playerjs-test.component';
import { BunnyPlayerjsTest2Component } from './features/videos/components/streaming-providers/bunny/components/bunny-playerjs-test2/bunny-playerjs-test2.component';
import { BunnyCdnTokenTestPageComponent } from './features/videos/components/bunny-cdn-token-test-page/bunny-cdn-token-test-page.component';
import { BunnyPlayerTestSettingsModalComponent } from './features/videos/components/bunny-player-test-settings-modal/bunny-player-test-settings-modal.component';
import { BunnyPlayerTestSettingsActionService } from './features/videos/actions/bunny-player-test-settings-action.service';
import { VidstackIframePlayerComponent } from './features/videos/components/vidstack-iframe-player/vidstack-iframe-player.component';
import { StudentCourseEndorsementActionModalComponent } from './features/schools/components/student-course-endorsement-action-modal/student-course-endorsement-action-modal.component';
import { StudentCourseEndorsementActionService } from './features/schools/actions/student-course-endorsement-action.service';
import { StudentCourseReportingVisibilityActionComponent } from './features/schools/actions/student-course-reporting-visibility-action.component';
import { VideoPlayerBunnyNewComponent } from './features/videos/components/streaming-providers/bunny/components/video-player-bunny-new/video-player-bunny-new.component';
import { CourseCopyActionService } from './features/courses/actions/copy-course-action.service';
import { ManageUsersGridRendererComponent } from './features/schools/components/manage-users-grid-renderer/manage-users-grid-renderer.component';
import { CourseProgressGridRendererComponent } from './features/reporting/components/course-progress-grid-renderer/course-progress-grid-renderer.component';
import { UsersGridRendererPrototypeComponent } from './features/shared/components/grids/users-grid-renderer-prototype/users-grid-renderer-prototype.component';
import { ManageUsersFilterTilesComponent } from './features/schools/components/manage-users-filter-tiles/manage-users-filter-tiles.component';
import { QuestionBankGridRendererComponent } from './features/quizzes/components/question-bank-grid-renderer/question-bank-grid-renderer.component';
import { QuizInsightsGridRendererComponent } from './features/quizzes/components/quiz-insights-grid-renderer/quiz-insights-grid-renderer.component';
import { QuizVideoCoveragePageComponent } from './features/quizzes/components/quiz-video-coverage-page/quiz-video-coverage-page.component';
import { QuizBuilderProPageComponent } from './features/quizzes/components/quiz-builder-pro-page/quiz-builder-pro-page.component';
import { G1000PrototypePageComponent } from './features/shared/components/g1000-prototype-page/g1000-prototype-page.component';
import { QuestionBankFilterTilesComponent } from './features/quizzes/components/question-bank-filter-tiles/question-bank-filter-tiles.component';
import { AviatorMetadataGridRendererComponent } from './features/shared/components/grids/aviator-metadata-grid-renderer/aviator-metadata-grid-renderer.component';
import { AviatorMetadataGridRendererConfigComponent } from './features/shared/components/grids/aviator-metadata-grid-renderer/config/aviator-metadata-grid-renderer-config.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { QuizTestModalComponent } from './features/quizzes/components/quiz-test-modal/quiz-test-modal.component';
import { ShowQuizTestModalActionService } from './features/quizzes/actions/show-quiz-test-modal-action.service';
import { CourseStudentProgressCardNewComponent } from './features/courses/components/cards/course-student-progress-card-new/course-student-progress-card-new.component';
import { CourseStudentProgressNoItemsCardComponent } from './features/courses/components/cards/course-student-progress-no-items-card/course-student-progress-no-items-card.component';
import { CourseStudentProgressFormCardNewComponent } from './features/courses/components/cards/course-student-progress-form-card-new/course-student-progress-form-card-new.component';
import { CourseStudentProgressSummaryCardComponent } from './features/courses/components/cards/course-student-progress-summary-card/course-student-progress-summary-card.component';
import { CourseStudentProgressSummaryFormCardComponent } from './features/courses/components/cards/course-student-progress-summary-form-card/course-student-progress-summary-form-card.component';
import { CourseStudentProgressSimpleCardComponent } from './features/courses/components/cards/course-student-progress-simple-card/course-student-progress-simple-card.component';
import { StartAiProcessingActionService } from './features/shared/actions/start-ai-processing-action.service';
import { LessonDetailViewComponent } from './features/courses/components/lesson-detail-view/lesson-detail-view.component';
import { CourseDocumentLinkFormSectionComponent } from './features/courses/components/course-document-link-form-section/course-document-link-form-section.component';
import { DocumentCourseLinkFormSectionComponent } from './features/documents/components/document-course-link-form-section/document-course-link-form-section.component';
import { DocumentVersionReferenceViewerFormSectionComponent } from './features/documents/components/document-version-reference-viewer-form-section/document-version-reference-viewer-form-section.component';
import { PostLoginAcknowledgementModalComponent } from './features/post-login/components/post-login-acknowledgement-modal/post-login-acknowledgement-modal.component';
import { AviatorTermsOfServiceManagerService } from './features/post-login/services/aviator-terms-of-service-manager.service';
import { AviatorGlobalErrorHandler } from './features/shared/services/aviator-global-error-handler.service';

const errorInterceptors = [];
if (environment.production) {
  errorInterceptors.push({
    provide: ErrorHandler,
    useClass: AviatorGlobalErrorHandler
  });
}
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    DwTaskContainerComponent,
    AviatorOnlineHomePageComponent,
    CourseCardComponent,
    CoursesCardRedesignComponent,
   // MarketplaceEmptyCardComponent,
    CourseNavigationComponent,
    ModuleCardComponent,
    LessonCardComponent,
    LessonNavigationComponent,
    LessonUiComponent,
    ModuleDetailViewComponent,
    CourseDetailViewComponent,
    CourseCapFormHostComponent,
    VideoHostComponent,
    VideoPlayerBunnyComponent,
    VideoPlayerBunnyHlsComponent,
    VideoPlayerApiVideoComponent,
//    VideoPlayerBaseComponent,
    QuizComponent,
    QuizQuestionComponent,
    QuizHomeComponent,
    QuizAnswerTrueFalseComponent,
    QuizAnswerMultipleChoiceComponent,
    QuizAnswerMultipleAnswerComponent,
    QuizAnswerBaseComponent,
    QuizAnswerHostComponent,
    QuizResultComponent,
    QuizResultsComponent,
    QuizCardComponent,
    TimeDurationPipe,
    LocalDateTimePipe,
    VideoUploadModalComponent,
    UserRegistrationComponent,
    CourseStudentProgressCardComponent,
    ModuleStudentProgressCardComponent,
    ModuleStudentProgressCardHeaderComponent,
    BaseCardComponent,
    DwCardDesignerComponent,
    CourseStudentProgressFormCardComponent,
    CourseStudentProgressComponent,
    CourseStudentProgressRedesignComponent,
    StudentModuleLessonActivityGridRendererComponent,
    LessonStudentProgressCardComponent,
    QuizResultsModalComponent,
    LinkQuestionsModalComponent,
    QuestionFormLayoutWidgetComponent,
    QuizFormLayoutWidgetComponent,
    AssignmentUtilComponent,
    AnnonymousHomeViewComponent,
    AuthenticatedHomeViewComponent,
    StudentDashboardComponent,
    LessonCardHomePageComponent,
    AssignmentCardComponent,
    UsreAvatarComponent,
    AssignCourseUtilComponent,
    VideoAdminPreviewComponent,
    AssignmentLessonCardComponent,
    AssignmentCardMyAssignmentsRedesignComponent,
    AssignmentStudentLessonProgressComponent,
    AssignmentStudentProgressFormSectionComponent,
    AssignmentStudentGridRendererComponent,
    AssignmentFormFooterStatusComponent,
    AssignmentsGridRendererComponent,
    SchoolDashboardComponent,
    InstructorDashboardComponent,
    MyStudentsGridRendererComponent,
    AddStudentByCodeModalComponent,
    StudentTrainingCodeFormSectionComponent,
    StudentCardComponent,
    DwMagicImage2Directive,
    DwImage2Component,
    ManagerUserUtilComponent,
    LessonSelectionTreeFormControlComponent,
    LessonSelectionTreeControlComponent,
    LessonSelectionListControlComponent,
    LessonSelectionListFormControlComponent,
    LessonSelectionReadonlyListFormControlComponent,
    AssignmentStatusFormControlComponent,
    AssignmentCourseFormControlComponent,
    ExpirationDateTimeReadonlyFormControlComponent,
    FlagLessonModalComponent,
    EndorsementStudentEditComponent,
    FlightSchoolSettingsComponent,
    FlightSchoolMarketplaceFormSectionComponent,
    LabPaymentsComponent,
    PaymentsCreatePaymentComponent,
    PaymentsAddPaymentComponent,
    StudentPurchaseCourseComponent,
    ChangeSchoolSubscriptionComponent, SchoolBillingDetailsComponent, SchoolBillingDetailsUtilComponent,
    BillingProfileFormSectionComponent,
    StudentBillingDetailsUtilComponent,
    SetUserTypeComponent,
    SchoolSelectionModalComponent,
    SchoolBrandingSetupComponent,
    DwThemePropertyEditorComponent,
    DwColorSetPickerComponent,
    DwMediaSelector2Component,
    VideoThumbnailComponent,
    StudentChangeSchoolModalComponent,
    AssignmentAddStudentsModalComponent,
    LabPaymentsComponent,
    PaymentsCreatePaymentComponent,
    PaymentsAddPaymentComponent, CoursePageComponent, PurchaseCourseModalComponent, DiscountCodeComponent,
    StudentOnboardingModalComponent,
    PurchaseCourseUtilComponent,
    DurationFormControlComponent,
    MobilePhoneFormControlComponent,
    PresetDateTimeFormControlConfigComponent,
    PresetDateTimeFormControlComponent,
    SelectedCourseReadonlyFormControlComponent,
    EmailAddressListControlComponent,
    JoinRequestEmailListFormSectionComponent,
    DomainListControlComponent,
    FlightSchoolRegistrationDomainsFormSectionComponent,
    StudentGroupSelectComponent,
    StudentGroupMultiSelectComponent,
    StudentGroupSelectFormSectionComponent,
    CoursePurchaseStudentGroupSelectFormSectionComponent,
    CourseMarketplaceCardComponent,
    MarketplaceEmptyCardRedesignComponent,
    ProfitSharingDetailsComponent,
    ProfitSharingSummaryComponent,
    DwMiniTileComponent,
    VideoModalComponent,
    DwImageZoomModalComponent,
    MainDashboardComponent,
    LessonCardHomePage2Component,
    ContinuingHomePageCardComponent,
    ContinuingHomePageCardRedesignComponent,
    UpNextHeroCardComponent,
    ProgramTileCardComponent,
    MainDashboardRedesignComponent,
    BreakUiHomepageComponent,
    BreakUiCoursesComponent,
    CertProgressHeaderComponent,
    StreakQuizCardMockComponent,
    DailyQuizPageComponent,
    StatStripMockComponent,
    DueSoonMockComponent,
    AchievementsPageComponent,
    LadderDetailSheetComponent,
    TierEarnedSheetComponent,
    AchievementsWithinReachMockComponent,
    CreateSchoolModalComponent,
    AssignmentCardNewComponent,
    AssignmentRowCardComponent,
    ChangeSchoolSubscriptionModalComponent,
    StandardProgressBarComponent,
    SubscriptionSettingsComponent,
    SubscriptionSettingsRedesignComponent,
    AssignmentBlankCardComponent,
    AssignmentBlankCardMyAssignmentsRedesignComponent,
    NoAssignmentsCardRedesignComponent,
    UserImageColumnComponent,
    AviatorLoginPageComponent,
    AviatorRegistrationPageComponent,
    AviatorLookupDropdownComponent,
    AviatorNotFoundComponent,
    CourseSubmitAcsWrittenActionService,
    CourseAcsWrittenResultsComponent,
    CourseAcsWrittenResultsAdminViewComponent,
    StudentActivityFormSectionComponent,
    NutrientPdfViewerComponent,
    DocumentCardComponent,
    DocumentPdfViewerComponent,
    FarAimViewerPageComponent,
    DocumentViewerComponent,
    DocumentReferenceViewerComponent,
    DocumentReferenceStructuredContentComponent,
    DocumentReferenceStructuredViewerComponent,
    DocumentEmbeddedViewerComponent,
    StructuredDocumentViewerComponent,
    StructuredDocumentContentComponent,
    DocumentItemAiProcessingComponent,
    FarAimProcessingComponent,
    FlightSchoolSettingsConfigComponent,
    ReportCourseTilesComponent,
    ReportCourseStatCardComponent,
    DocumentLessonComponent,
    ReportingPageComponent,
    UserAvatorComponent,
    AviatorAvatarComponent,
    AviatorAvatarColumnComponent,
    AviatorAvatarColumnConfigComponent,
    VideoThumbnailGridColumnComponent,
    DateRangeFilterComponent,
    EmptyStateComponent,
    ReportingSkeletonComponent,
    ReportingUsersDetailGridComponent,
    //SideEditComponent, 
    DocumentEditComponent,
    DocumentsPageComponent,
    DocumentCardOldComponent,
    SideEditSheetComponent,
    FolderEditComponent,
    FolderSelectorComponent,
    AddDocumentDropdownComponent,
    ToggleSwitchComponent,
    ManageUserCalloutsComponent,
    DwPubSubMonitorComponent,
    ManageUsersSkeletonComponent,
    ManageUsersTableComponent,
    BunnyPlayerjsTestComponent,
    BunnyPlayerjsTest2Component,
    BunnyCdnTokenTestPageComponent,
    BunnyPlayerTestSettingsModalComponent,
    VidstackIframePlayerComponent,
    StudentCourseEndorsementActionModalComponent,
    StudentCourseReportingVisibilityActionComponent,
    VideoPlayerBunnyNewComponent,
    ManageUsersGridRendererComponent,
    CourseProgressGridRendererComponent,
    UsersGridRendererPrototypeComponent,
    AviatorMetadataGridRendererComponent,
    AviatorMetadataGridRendererConfigComponent,

    ManageUsersFilterTilesComponent,
    QuestionBankGridRendererComponent,
    QuizInsightsGridRendererComponent,
    QuizVideoCoveragePageComponent,
    QuizBuilderProPageComponent,
    G1000PrototypePageComponent,
    TagsGridRendererComponent,
    QuestionBankFilterTilesComponent,

    QuizTestModalComponent,
    CourseStudentProgressCardNewComponent,
    CourseStudentProgressNoItemsCardComponent,
    CourseStudentProgressFormCardNewComponent,
    CourseStudentProgressSummaryCardComponent,
    CourseStudentProgressSummaryFormCardComponent,
    CourseStudentProgressSimpleCardComponent,
    LessonDetailViewComponent,
    CourseDocumentLinkFormSectionComponent,
    DocumentCourseLinkFormSectionComponent,
    DocumentVersionReferenceViewerFormSectionComponent,
    LoginSideImagePickerComponent,
    PostLoginAcknowledgementModalComponent
  ],
  imports: [
   // ReportingModule, // Changed to be part of the same module
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    //NgxStripeModule.forRoot(globalThis.stripe.key),
    ReactiveFormsModule,
    OrderListModule,
    InputSwitchModule,
    TabViewModule,
    DropdownModule,
    DragDropModule,
    MultiSelectModule,
    AutoCompleteModule,
    CheckboxModule,
    TreeModule,
    SliderModule,
    GalleriaModule,

    HttpClientModule,
    AgGridModule.forRoot(),
    BsDropdownModule.forRoot(),
    ChartModule,

    DevwareCoreModule,
    DevwareOrmModule,
    DevwareUIModule,
    DevwareAGGridModule,
    DevwareUILayoutModule,
    DevwareUIMetaDataModule,
    DevwareUiWizardModule,
    DevwareAdminModule,
    DevwareMediaModule,
    DevwareChartsModule,
    ProgressBarModule,
    AppRoutingModule,
    ScrollingModule,
    InfiniteScrollModule,
    DesignSystemModule,
    ScenariosModule
  ],
  providers: [
      AppDevwareConfigProviderService,
      AppDevwareBootstrapService,
      CourseHelperContextContextService,
      CurrentUserContextService,
      CurrentStudentContextService,
    CourseBreadcrumbProcessor,
    DocumentsBreadcrumbProcessor,
    CourstListDataSourceService,
    ModuleListDataSourceService,
    LessonListDataSourceService,
    StudentCourseProgressListDataSourceService,
    VideoUploadActionService,
    CurrentFlightSchoolContextService,
    ShowQuizResultModalActionService,
    LinkQuestionActionsService,
    CustomerPortalViewActionService,
    EnabledProfitSharingActionService,
    ResetProfitSharingActionService,
    AssignmentStudentDetailActionService,
    AssignmentStudentSetProgressActionService,
    AssignmentStudentCurrentDataSourceService,
    DurationSecondsColumnRendererService,
    UrlParameterContextService,
    ManageStudentContextService,
    AssignmentStudentDataSourceService,
    StudentCourseDeleteActionService,
    StudentResetCourseProgressActionService,
    InstructorStudentDataSourceService,
    AddStudentByCodeActionService,
    CurrentInstructorContextService,
    SchoolStudentDataSourceService,
    ModuleProgressListDataSourceService,
    MyFlightSchoolContextService,
    VideoReplaceFormActionService,
    VideoRevertToHistoryActionService,
    VideoUpdateStatusActionService,
    UserRoleDetailsContextService,
    DwAssignmentLessonCountValidationRule,
    DwAssignmentStudentCountValidationRule,
    UpdateAllStudentProgressActionService,
    ReprocessStudentGamificationActionService,
    DeleteDailyQuizActionService,
    InstructorAssignStudentsSaveActionService,
    UserBreadcrumbProcessor,
    StudentCourseEndorsementContextService,
    StudentCourseTimeSpentContextService,
    StudentUpdateCourseProgressActionService,
    RegardeQuizActionsService,
    ResendJoinRequestActionService,
    SchoolSelectionModalActionService,
    StudentOnboardingActionService,
    TestEmulatedAcknowledgementsActionService,
    SchoolSettingsDataSourceService,
    StudentChangeSchoolActionService,
    CourstListMarketplaceDataSourceService,
    CoursePurchaseActionService,
    SchoolFeatureContextService,
    CourseTotalTimeUpdateActionService,
    CourseAssignAllSchoolsActionService,
    AviatorRouteGuardService,
    RemovePaymentMethodActionService,
    RecreateProcessorCustomerActionService,
    SchoolSelectGridAction,
    EmulateUserContextGridActionService,
    EmulateUserContextFormActionService,
    CourseLessonProgressAssignmentDataSourceService,
    AssignmentStudentHomePageDataSourceService,
    LessonAssignAcsTasksAction,
    DwLoginRegistrationInfoProviderService,
    StudentModuleProgressContextService,
    AssignmentStudentAddModalService,
    AssignmentAddStudentsActionService,
    RecreateEndorsementsActionService,
    ReundInvoiceActionService,
    OpenStripeInvoiceActionService,
    StudentCourseEndorsementActionService,
    CourseCopyActionService,
    ShowQuizTestModalActionService,
    StartAiProcessingActionService,
    BunnyPlayerTestSettingsActionService,
    {
      provide: DwTermsOfServiceManagerService,
      useClass: AviatorTermsOfServiceManagerService
    },
    {
      provide: DwMetaDataListService,
      useClass: AviatorMetadataListService
    },
    {
      provide: DwMetaDataGridService,
      useClass: QuizInsightsGridConfigService
    },
    {
      provide: DwUserContextDynamicHandlerToken,
      useClass: AviatorUserContextCustomizerService
    },
    {
      provide: DwMenuProcessorToken,
      useClass: SidebarSectionMenuProcessorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SchoolOverrideHttpInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: IntegrationDataHttpInterceptor,
      multi: true
    },
    ...errorInterceptors
    // {
    //   provide: ErrorHandler, 
    //   useClass: DwGlobalErrorHandler
    // },
  ],
  bootstrap: [AppComponent],
  exports: [
    //UserRegistrationComponent
  ]
})
export class AppModule { }
